// React
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom'
// ユーティリティ
import { menu } from '../../../../constants'
import { useAuth } from '../../../../context/AuthContext';
import { validationSchema } from '../../../../utils/validationUtils';
import { errorMessages } from '../../../../utils/messagesUtils';

import sty from '../../Settings/Settings.module.css';

const UpdatePasswordInput = ({ onClick }) => {
    const navigate = useNavigate()
    const { role } = useAuth()
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: 'onBlur', // フォーカスが外れたときにバリデーションを実行
    });
    const [errorFromServer, setErrorFromServer] = useState('');
    
    const onSubmit = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/settings/password/change`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
                credentials: 'include'
            });
            const result = await response.json();
            if (response.status === 200 && result.status === 'OK') {
                // パスワード変更完了画面に遷移
                onClick();
            } else {
                if(result.message === 'logout'){
                    navigate(role === 1 ? menu.MNG.SIGNIN.PATH : menu.ENGINEER.SIGNIN.PATH);
                } else if (response.status === 401) { 
                    // パスワード認証エラー
                    const error = new Error();
                    error.front_message = errorMessages.account_settings.invalid_password;
                    throw error;
                }else{
                    // それ以外のエラー
                    const error = new Error();
                    error.front_message = errorMessages.account_settings.password_change_failed;
                    throw error;
                }
            }
        } catch (e) {
            setErrorFromServer(e.front_message || errorMessages.api.server_error)
        }
    };
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [pwdNewVisible, setpwdNewVisible] = useState(false);
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePwdNewVisibility = () => {
        setpwdNewVisible(!pwdNewVisible);
    };
    return (
        <form onSubmit={handleSubmit(onSubmit)} className={sty['form']} data-testid="profile-form">
            <div className="inner-container">
                {errorFromServer && <p className='account-error-msg'>{errorFromServer}</p>}
                <div className={`${sty['form__label-flex-settings']} ${sty['form__label-flex-mb']}`}>
                    <div className={sty['form__label']}>現在のパスワード</div>
                    <input
                        {...register('password', validationSchema.password)}
                        type={passwordVisible ? 'text' : 'password'}
                        className={sty['password__pass-input-field']} placeholder="現在のパスワードを入力してください"
                    />
                    {errors.password && <p className="form__validation-msg">{errors.password.message}</p>}
                    <img src={passwordVisible ? '/images/open.svg' : '/images/hidden.svg'}
                        alt="パスワード表示・非表示" className={`${sty['password__pass-toggle']} ${passwordVisible ? sty['password__pass-toggle--open'] : ''}`}
                        onClick={togglePasswordVisibility}
                    />
                </div>
                <div className={`${sty['form__label-flex-settings']} ${sty['form__label-flex-mb']}`}>
                    <div className={sty['form__label']}>新しいパスワード</div>
                    <input
                        {...register('pwd_new', validationSchema.password)}
                        type={pwdNewVisible ? 'text' : 'password'}
                        className={sty['password__pass-input-field']} placeholder="新しいパスワードを入力してください"
                    />
                    {errors.pwd_new && <p className="form__validation-msg">{errors.pwd_new.message}</p>}
                    <img src={pwdNewVisible ? '/images/open.svg' : '/images/hidden.svg'}
                        alt="パスワード表示・非表示" className={`${sty['password__pass-toggle']} ${pwdNewVisible ? sty['password__pass-toggle--open'] : ''}`}
                        onClick={togglePwdNewVisibility}
                    />
                </div>
                <div
                    className={
                        sty['password__pass-available-symbols']
                    }
                >
                    使用可能な記号 @$!%*?&
                </div>
            </div>
            <div className="primary-btns">
                <button type="submit" className="primary-btn">変更</button>
            </div>
        </form >
    )
}
export default UpdatePasswordInput;